import { render, staticRenderFns } from "./TermSearchField.vue?vue&type=template&id=37fef4c4&scoped=true"
import script from "./TermSearchField.vue?vue&type=script&lang=js"
export * from "./TermSearchField.vue?vue&type=script&lang=js"
import style0 from "./TermSearchField.vue?vue&type=style&index=0&id=37fef4c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fef4c4",
  null
  
)

export default component.exports